(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll("[data-sb-hero]").forEach(function (root) {
      var track = root.querySelector("[data-sb-track]");
      if (!track || root.dataset.sbInit) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;
      root.dataset.sbInit = "1";
      var dotsWrap = root.querySelector("[data-sb-dots]");
      var index = 0, timer = null;
      var dots = slides.map(function (_, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Go to slide " + (i + 1));
        b.addEventListener("click", function () { go(i, true); });
        if (dotsWrap) dotsWrap.appendChild(b);
        return b;
      });
      function render() {
        track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === index); });
      }
      function go(n, manual) { index = (n + slides.length) % slides.length; render(); if (manual) restart(); }
      function restart() { if (timer) clearInterval(timer); timer = setInterval(function () { go(index + 1); }, 5000); }
      var pv = root.querySelector("[data-sb-prev]"), nx = root.querySelector("[data-sb-next]");
      if (pv) pv.addEventListener("click", function () { go(index - 1, true); });
      if (nx) nx.addEventListener("click", function () { go(index + 1, true); });
      root.addEventListener("mouseenter", function () { if (timer) clearInterval(timer); });
      root.addEventListener("mouseleave", restart);
      render(); restart();
    });
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll("[data-sb-carousel]").forEach(function (root) {
      var track = root.querySelector("[data-sb-track]");
      if (!track || root.dataset.sbInit) return;
      root.dataset.sbInit = "1";
      function step() {
        var it = track.querySelector(".sb-card");
        var gap = parseInt(getComputedStyle(track).columnGap || "16", 10) || 16;
        return it ? it.getBoundingClientRect().width + gap : 300;
      }
      var p = root.querySelector("[data-sb-prev]");
      var n = root.querySelector("[data-sb-next]");
      if (p) p.addEventListener("click", function () { track.scrollBy({ left: -step() * 2, behavior: "smooth" }); });
      if (n) n.addEventListener("click", function () { track.scrollBy({ left: step() * 2, behavior: "smooth" }); });
    });
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-more-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll("[data-sb-more]").forEach(function (root) {
      var track = root.querySelector("[data-sb-more-track]");
      if (!track || root.dataset.sbInit) return;
      root.dataset.sbInit = "1";
      function step() {
        var it = track.querySelector(".sb-more__card");
        var gap = parseInt(getComputedStyle(track).columnGap || "16", 10) || 16;
        return it ? it.getBoundingClientRect().width + gap : 300;
      }
      var p = root.querySelector("[data-sb-more-prev]");
      var n = root.querySelector("[data-sb-more-next]");
      if (p) p.addEventListener("click", function () { track.scrollBy({ left: -step() * 2, behavior: "smooth" }); });
      if (n) n.addEventListener("click", function () { track.scrollBy({ left: step() * 2, behavior: "smooth" }); });
    });
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();

  } catch(e) { console.error(e); }
})();
})();
